// extracted by mini-css-extract-plugin
module.exports = {"container":"coatError_container__7_kwx","text":"coatError_text__fAeAD"};